module.exports = __webpack_public_path__ + "media/newstyle/images/hero-book-image-7538158ce80261212d7271c98afe8bed.png";